import * as p from "pako"

export function ungzip(a: any, q1: any) {
	return p.ungzip(a, q1);
}
